var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("header", [
        _c("h2", { staticClass: "mb-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Lecture du fichier CSV")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fs-3 gray-80 mt-2 mb-0" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Nous avons besoin de vous pour lire et interpréter les différentes colonnes et lignes de votre document."
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fs-3 gray-80 mt-0" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Nous enregistrerons ces informations pour faciliter vos futurs imports."
                )
              ) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [_vm._t("content")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4" }, [
        _c(
          "div",
          { staticClass: "aright" },
          [
            _vm._t("footer", [
              _vm.previousStep
                ? _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.labels.previous"),
                      type: "secondary",
                      disabled: _vm.loading
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("previous")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.nextStep
                ? _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.continue"),
                      type: "primary",
                      disabled: _vm.loading
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("next")
                      }
                    }
                  })
                : _vm._e()
            ])
          ],
          2
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }